import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import UltraAdminLoginScreen from './UltraAdminLoginScreen';
import UltraAdminPage from './UltraAdminPage';

const ULTRA_ADMIN_UID = 'ADA5WZOA5UNIai1WaE52S33DvX73';

function UltraAdmin() {
    const { user, loading } = useAuth();
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    // Handle successful login
    const handleLoginSuccess = () => {
        console.log('[UltraAdmin] Login success callback called');
        setIsAuthenticated(true);
    };

    // Check if user becomes ultra admin after auth state changes
    useEffect(() => {
        if (user && user.uid === ULTRA_ADMIN_UID) {
            console.log('[UltraAdmin] Ultra admin user detected, setting authenticated');
            setIsAuthenticated(true);
        } else if (user && user.uid !== ULTRA_ADMIN_UID) {
            console.log('[UltraAdmin] Non-ultra admin user detected, clearing authenticated');
            setIsAuthenticated(false);
        } else if (!user) {
            console.log('[UltraAdmin] No user, clearing authenticated');
            setIsAuthenticated(false);
        }
    }, [user]);

    // Show loading while auth is initializing
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-100">
                <p className="text-lg text-gray-600">Loading...</p>
            </div>
        );
    }

    // Check if user is the ultra admin and authenticated
    const isUltraAdmin = user && user.uid === ULTRA_ADMIN_UID;
    const shouldShowDashboard = isUltraAdmin && isAuthenticated;

    console.log('[UltraAdmin] Render state:', {
        hasUser: !!user,
        userUid: user?.uid,
        isUltraAdmin,
        isAuthenticated,
        shouldShowDashboard
    });

    if (shouldShowDashboard) {
        return <UltraAdminPage />;
    } else {
        return <UltraAdminLoginScreen onLoginSuccess={handleLoginSuccess} />;
    }
}

export default UltraAdmin; 